import { z } from 'zod';
import { accountSchema } from '../entities/accountTypes';
export const registerAccountFunctionDef = {
    name: 'registerAccount',
    requestSchema: accountSchema.extend({
        systemRole: z.union([accountSchema.shape.systemRole.optional(), z.null(), z.undefined()]), // this value is set to `null` upon registration, need investigation, add additional types to be safer
        systemStatus: z.union([accountSchema.shape.systemStatus.optional(), z.null(), z.undefined()]),
    }),
    responseSchema: z.void(),
};
